module.exports = __webpack_public_path__ + "static/media/groomingPageEarIcon.2f40e092.png";